angular.module('zc.zenclerkS')
  .factory('StateBeforeActionRunner', StateBeforeActionRunner);

StateBeforeActionRunner.$inject = ['$injector', '$q', '$rootScope', '$state', 'Devise'];
function StateBeforeActionRunner($injector, $q, $rootScope, $state, Devise) {
  return {
    initialize: initialize,
  };

  function initialize() {
    // Calls recursively beforeAction of each state if it exists,
    // in the order that parents are called first
    // ex. When going to 'xxx.yyy.zzz', call first xxx, then xxx.yyy, then xxx.yyy.zzz
    // If beforeAction returns falsy, stop calling subsequent ones
    const eventListener = $rootScope.$on('$stateChangeStart', (event, toState, toParams, fromState, fromParams) => {
      if(!toState) return;

      const beforeActions = _.chain(toState.name.split('.'))
        .map((atom, index) => _.slice(toState.name.split('.'), 0, index + 1).join('.'))
        .map(name => $state.get(name))
        .filter(state => state.beforeAction)
        .value();

      const callFromStateRoot = (remainingActions, locals) => {
        if(remainingActions.length === 0) return;

        $q(resolve => resolve())
          .then(() => $injector.invoke(remainingActions[0].beforeAction, this, locals))
          .then(flg => {
            if(_.isUndefined(flg)) {
              console.warn('WARNING: Got undefined from beforeAction', remainingActions[0].name);
            } else if(!_.isBoolean(flg)) {
              console.warn('WARNING: Got non-boolean from beforeAction', remainingActions[0].name);
            }

            if(!flg) {
              event.preventDefault();
            } else {
              callFromStateRoot(_.slice(remainingActions, 1), locals);
            }
          });
      };

      Devise.getCurrentUser()
        .then(currentUser => {
          let locals = {
            event: event,
            toState: toState,
            toParams: toParams,
            fromState: fromState,
            fromParams: fromParams,
            currentUser: currentUser,
          };

          callFromStateRoot(beforeActions, locals);
        });
    });

    // Not really needed but good practice to destroy the listener
    $rootScope.$on('$destroy', () => eventListener());
  }
}



// WEBPACK FOOTER //
// ./src/zenclerk_s_modules/services/state_before_action_runner.service.js